import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthContext.js';

export function AcceptInvite({ token }: { token: string }) {
  const { acceptInvite } = useAuth();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (password !== confirm) { setError('Passwords don’t match.'); return; }
    setBusy(true); setError(null);
    try {
      await acceptInvite(token, password);
      // Drop the ?token= from the URL once accepted.
      window.history.replaceState({}, '', window.location.pathname);
    } catch {
      setError('This invitation link is invalid or has expired. Ask the host to re-invite you.');
    } finally { setBusy(false); }
  }

  return (
    <main className="min-h-screen grid place-items-center p-8">
      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-7">
        <div className="text-center space-y-3">
          <p className="text-[11.5px] text-amber/80">martindaigneault.ai</p>
          <h1 className="font-serif text-4xl text-ink leading-tight">
            You’ve been <em className="italic text-particle">invited</em>.
          </h1>
          <p className="font-serif italic text-ink/60 text-sm">
            Set a password to step into the crystal and converse.
          </p>
        </div>
        <div className="space-y-3">
          <input type="password" placeholder="choose a password" value={password} autoFocus
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border border-ink/15 bg-white/[0.02] font-serif text-ink focus:border-ink/40 focus:outline-none" />
          <input type="password" placeholder="confirm password" value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border border-ink/15 bg-white/[0.02] font-serif text-ink focus:border-ink/40 focus:outline-none" />
        </div>
        {error && <p className="text-[12px] text-red-300 text-center">{error}</p>}
        <button type="submit" disabled={busy}
          className="w-full py-3 rounded-full bg-ink text-void text-[11px] hover:bg-particle transition-colors disabled:opacity-40">
          {busy ? 'Entering…' : 'Accept & enter'}
        </button>
      </form>
    </main>
  );
}
